/*
auto-generated by: https://github.com/react-spring/gltfjsx
*/

import React, { useRef } from "react"
import { useLoader } from "react-three-fiber"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import { draco } from "drei"

export default function Model(props) {
  const group = useRef()
  const { nodes, materials } = useLoader(
    GLTFLoader,
    "/logo.glb",
    draco("/draco-gltf/")
  )
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        material={materials.SVGMat}
        geometry={nodes.Curve001.geometry}
        position={[-18, -10, 0]}
        scale={[230, 230, 230]}
      />
    </group>
  )
}
